import type { ReactNode } from "react";

type Props = {
  eyebrow?: ReactNode;
  title: ReactNode;
  accent?: ReactNode;
  subtitle?: ReactNode;
};

export function PageHeader({ eyebrow, title, accent, subtitle }: Props) {
  return (
    <div className="text-center pt-20 pb-4 px-6">
      {eyebrow && (
        <div className="mb-4 text-sm font-medium text-emerald-700 dark:text-emerald-400">
          {eyebrow}
        </div>
      )}
      <h1 className="text-4xl md:text-5xl font-semibold tracking-tight text-slate-900 dark:text-slate-100">
        {title}
        {accent && (
          <>
            {" "}
            <span className="text-gradient-accent">{accent}</span>
          </>
        )}
      </h1>
      {subtitle && (
        <p className="mt-4 text-slate-600 max-w-2xl mx-auto dark:text-slate-400">
          {subtitle}
        </p>
      )}
    </div>
  );
}
